module.exports = __webpack_public_path__ + "static/assets/974d91a399c151a083c3bb7c132f30c1.svg";